type AskAnythingLogoProps = {
  size?: number;
};

export function NewQuackLogo({ size = 24 }: AskAnythingLogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22.3717 19.7926"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.74665e-08 9.3428C7.09044e-08 4.18291 4.18274 3.98274e-08 9.3424 0C14.5021 -3.98274e-08 18.6848 4.18291 18.6848 9.3428V9.89632C18.6848 15.3619 14.2543 19.7926 8.78891 19.7926H0L4.74665e-08 9.3428Z"
        fill="#EEBF49"
      />
      <path
        d="M13.7001 7.35779C13.7001 8.48375 12.7882 9.39652 11.6633 9.39652C10.5385 9.39652 9.62657 8.48375 9.62657 7.35779C9.62657 6.23183 10.5385 5.31906 11.6633 5.31906C12.7882 5.31906 13.7001 6.23183 13.7001 7.35779Z"
        fill="#1D1D1D"
      />
      <path
        d="M12.1509 5.76227C12.3221 5.76227 12.4609 5.90117 12.4609 6.07251C12.4609 6.24386 12.3221 6.38275 12.1509 6.38275C12.1336 6.38275 12.1166 6.38129 12.1 6.37854C12.0595 6.63215 11.8401 6.82596 11.5753 6.82596C11.2819 6.82596 11.044 6.58784 11.044 6.29412C11.044 6.00039 11.2819 5.76228 11.5753 5.76227C11.7014 5.76227 11.8171 5.80622 11.9082 5.8796C11.965 5.80811 12.0526 5.76227 12.1509 5.76227Z"
        fill="#EAE6DD"
      />
      <path
        d="M18.9242 8.82766C19.9295 7.63982 19.9245 6.95494 20.6444 6.45843C21.0712 6.16404 21.6183 5.94454 22.1384 5.84632C22.1458 5.85659 22.1529 5.86745 22.1596 5.87897C22.4682 6.41192 22.8048 8.43786 20.3102 9.90936C17.2703 11.7025 15.2604 10.9424 15.062 10.6489C16.1756 10.3747 18.0203 9.89576 18.9242 8.82766Z"
        fill="#EE6B26"
      />
      <path
        d="M17.2826 5.64741C18.0681 5.24902 18.806 6.30675 20.3329 6.06085C21.0256 5.94929 21.8916 5.43844 22.1361 5.84736C21.6166 5.94576 21.0706 6.16442 20.6444 6.45843C19.9245 6.95494 19.9295 7.63982 18.9242 8.82766C18.0203 9.89576 16.1756 10.3747 15.062 10.6489C15.062 10.6489 15.062 10.649 15.062 10.6489C14.9296 10.4297 14.5848 10.0494 15.7134 8.95061C17.1242 7.57712 16.0583 6.2684 17.2826 5.64741Z"
        fill="#FF8F8F"
      />
    </svg>
  );
}
